import Model from "../../model"
import { ID, FleetingIdea } from "../../types"

import Command, { CommandName } from "../command"
import CreateFleetingIdeaCommand from "./create_fleeting_idea_command"

export type DeleteFleetingIdeaCommandState = {
  id: ID
  captured?: {
    fleetingIdea: FleetingIdea
  }
}

export default class DeleteFleetingIdeaCommand extends Command {
  name: CommandName = "delete-fleeting-idea"
  state: DeleteFleetingIdeaCommandState

  constructor(state: DeleteFleetingIdeaCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - already deleted (Cancel)
  resolveConflicts(model: Model): DeleteFleetingIdeaCommandState | null {
    if (!model.getFleetingIdea(this.state.id)) return null
    return this.state
  }

  local(model: Model): any {
    this.state.captured = {
      fleetingIdea: model.fetchFleetingIdea(this.state.id),
    }
    model.deleteFleetingIdea(this.state.id)
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("No captured state")
    return [
      new CreateFleetingIdeaCommand({
        id: this.state.id,
        fleetingIdea: this.state.captured.fleetingIdea,
      }),
    ]
  }
}
